import store from '@/store';
import axios from 'axios';
import moment from 'moment';
import { translate } from '@/utils/translate';
import * as echoApi from './echoApi';
import _ from 'lodash';

// -------------------------------------------------- FUNCTIONS -----------------------------------------------------------------
// GET USER DATA
export function getUserData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.UserApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response.data)
        // localStorage.setItem('authUser2', btoa(JSON.stringify(response.data)))
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.UserApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                resolve(response.data);
              });
          });
        }
        reject(error);
      });
  });
}
/**
 * * fetching projects
 */
export function getProjectsData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.ProjectsApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response)
        response.data.map(project => {
          if (project.start_date) {
            project.start_date_formated = setDateFormatFromUtc(
              project.start_date
            );
          }
          if (project.deadline_date) {
            project.deadline_date_formated = setDateFormatFromUtc(
              project.deadline_date
            );
          }
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get(
                'https://' + store.state.data.hostname + echoApi.ProjectsApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response)
                response.data.map(project => {
                  if (project.start_date) {
                    project.start_date_formated = setDateFormatFromUtc(
                      project.start_date
                    );
                  }
                  if (project.deadline_date) {
                    project.deadline_date_formated = setDateFormatFromUtc(
                      project.deadline_date
                    );
                  }
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}
/**
 *
 * * @param {*} projects
 * * @param {*} tasks
 * * grouping tasks to their projects
 */
export function formatProjects (projects, tasks) {
  // for (let i = 0; i < projects.length; i++) {
  //   projects[i].tasks = tasks.filter(task => task.project_id === projects[i].id)
  // }
  projects.map(project => {
    project.tasks = tasks.filter(
      task => task.project_id === project.id && task.archived === 0
    );
  });
  return projects;
}
// GET TASKS DATA & FORMAT
/**
 * * fetching tasks
 */
export function getTasksData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.TasksApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        response.data.map(task => {
          if (task.c_stamp) {
            task.c_stamp = setDateTimeFormatFromUtc(task.c_stamp);
          }
          if (task.m_stamp) {
            task.c_stamp = setDateTimeFormatFromUtc(task.m_stamp);
          }
          if (task.deadline_date) {
            task.deadline_date = setDateFormatFromUtc(task.deadline_date);
          }
        });
        resolve(response.data);
        // console.log(response)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.TasksApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response)
                response.data.map(task => {
                  if (task.c_stamp) {
                    task.c_stamp = setDateTimeFormatFromUtc(task.c_stamp);
                  }
                  if (task.m_stamp) {
                    task.c_stamp = setDateTimeFormatFromUtc(task.m_stamp);
                  }
                  if (task.deadline_date) {
                    task.deadline_date = setDateFormatFromUtc(
                      task.deadline_date
                    );
                  }
                });
                resolve(response.data);
                // console.log(response)
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function filterArchivedTasks (tasks, projects) {
  // var test
  // var Title = i18n.t('tables.Task')
  var Title = translate('B2B_Task');
  var Project = translate('Project');
  var Assignee = translate('Assignee');
  var Complete = translate('Completed');
  let tableData = tasks
    .filter(task => task.archived === 1)
    .map(task => {
      let project = projects.find(project => project.id === task.project_id);
      let projectName = project.title || '-';
      let obj = {};
      obj[Title] = task.title;
      obj[Project] = projectName;
      obj[Assignee] = task.contact_name;
      obj[Complete] = task.m_stamp;
      obj.id = task.id;
      return obj;
    });
  tableData['columns'] = [
    { label: Title },
    { label: Project },
    { label: Assignee },
    { label: Complete }
  ];
  // console.log(tableData)
  return tableData;
}
// GET MEETING DATA & FORMAT
export function getMeetingData () {
  let date = moment()
    .startOf('day')
    .unix();
  // console.log('date:' + date)
  // let date = '1515951522'
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.EventsApi + date, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        response.data.map(meeting => {
          meeting.date = setDateFormatFromUnix(meeting.dateTime);
          meeting.time = setTimeFormatFromUnix(meeting.dateTime);
          meeting.dateTime = setDateTimeFormatFromUnix(meeting.dateTime);
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get(
                'https://' +
                  store.state.data.hostname +
                  echoApi.EventsApi +
                  date,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                response.data.map(meeting => {
                  meeting.date = setDateFormatFromUtc(meeting.datetime);
                  meeting.time = setTimeFormatFromUtc(meeting.datetime);
                  meeting.dateTime = setDateTimeFormatFromUtc(meeting.datetime);
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}
/**
 * * fetching meeting data from the beggining of the current year
 * * i use moment to get the start or the year in unix timestamp
 */
export function getMeetingDataStartOfYear () {
  let startOfYear = moment()
    .startOf('year')
    .unix();
  // console.log('startOfYear:' + startOfYear)
  return new Promise((resolve, reject) => {
    axios
      .get(
        'https://' +
          store.state.data.hostname +
          echoApi.EventsApi +
          startOfYear,
        { headers: echoApi.getHeader() }
      )
      .then(function (response) {
        // handle success
        // console.log(response)
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get(
                'https://' +
                  store.state.data.hostname +
                  echoApi.EventsApi +
                  startOfYear,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response)
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}
/**
 *
 * * @param {*} data
 * * setting events on the calendar
 */
export function getCalendarTodos (data) {
  // console.log(data)
  const todos = [];
  let date = '';
  // let curDate = moment().format('YYYY, M, D')
  // let isComplete
  for (let i = 0; i < data.length; i++) {
    date = moment.unix(data[i].dateTime).format('YYYY, M, D');
    // if (curDate >= date) { isComplete = true } else { isComplete = false }
    todos[i] = {
      description: data[i].description,
      isComplete: false,
      dates: new Date(date),
      color: localStorage.getItem('appPrimaryColor')
    };
    // console.log(startOfYear)
    // this.todos[i].push(data[i])
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(todos);
    }, 500);
  });
}
// GET TICKETS DATA & FORMAT
export function getTicketsData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.TicketsApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        response.data.map(ticket => {
          // Formating date and time on tickets
          ticket.c_stamp = setDateTimeFormatFromUtc(ticket.c_stamp);
          ticket.m_stamp = setDateTimeFormatFromUtc(ticket.m_stamp);
          // Formating date and time on threads
          if (ticket.thread) {
            ticket.thread.map(thread => {
              thread.c_stamp = setDateTimeFormatFromUtc(thread.c_stamp);
              thread.m_stamp = setDateTimeFormatFromUtc(thread.m_stamp);
            });
          }
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get(
                'https://' + store.state.data.hostname + echoApi.TicketsApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                response.data.map(ticket => {
                  // Formating date and time on tickets
                  ticket.c_stamp = setDateTimeFormatFromUtc(ticket.c_stamp);
                  ticket.m_stamp = setDateTimeFormatFromUtc(ticket.m_stamp);
                  // Formating date and time on threads
                  if (ticket.thread) {
                    ticket.thread.map(thread => {
                      thread.c_stamp = setDateTimeFormatFromUtc(thread.c_stamp);
                      thread.m_stamp = setDateTimeFormatFromUtc(thread.m_stamp);
                    });
                  }
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function getPentingResolvedTickets (data) {
  let rate = {};
  let r = 0;
  let p = 0;
  data.filter(ticket => {
    if (ticket.resolved === 1) {
      r++;
    } else if (ticket.resolved === 0) {
      p++;
    }
  });
  rate.resolved = r;
  rate.pending = p;
  return rate;
}

export function getFilteredTickets (tickets, status) {
  var resolved = [];
  // let tickets2 = JSON.parse(JSON.stringify(tickets)) // ! i am creating a copy of my AllTickets state object, in order to format date and changes don't change my raw data i get from api call
  tickets.map(ticket => {
    // if (order.date > PastDate) {
    //   alert('megaliteri' + order.date + ',' + PastDate)
    // }
    // ticket.c_stamp = moment.utc(ticket.c_stamp).local().format('DD.MM.YYYY HH:mm')
    // ticket.m_stamp = moment(ticket.m_stamp).format('DD.MM.YYYY')
    // ticket.c_stamp = setDateTimeFormatFromUtc(ticket.c_stamp)
    // ticket.m_stamp = setDateTimeFormatFromUtc(ticket.m_stamp)
    ticket.priorityWords = ticket.priority;
    switch (ticket.priorityWords) {
      case 3:
        ticket.priorityWords = translate('b2b_High');
        break;
      case 4:
        ticket.priorityWords = translate('b2b_Normal');
        break;
      case 5:
        ticket.priorityWords = translate('b2b_Low');
        break;
    }
    if (status === 'unresolved') {
      if (ticket.resolved === 0) {
        resolved.push(ticket);
      }
    } else if (status === 'resolved') {
      if (ticket.resolved === 1) {
        resolved.push(ticket);
      }
    }
  });
  return resolved.reverse();
}

/**
 *
 * * @param {*} id
 * * @param {*} tickets
 * * filter all tickets to get the one we want based the id param and display all details
 */
export function getTicketDetails (id, tickets) {
  let x = JSON.parse(JSON.stringify(tickets)).filter(
    details => details.id === parseInt(id)
  ); // ! i am creating a copy of my AllTickets state object, in order to format date and changes don't change my raw data i get from api call
  // let z = x[0]
  x.map(test => {
    // console.log({c_stamp: file.c_stamp})
    // file.c_stamp = moment(file.c_stamp).format('DD MMM YYYY')
    // test.c_stamp = moment.utc(test.c_stamp).local().format('DD-MM-YYYY HH:mm')
    // test.m_stamp = moment.utc(test.m_stamp).local().format('DD-MM-YYYY')
    test.priorityWords = test.priority;
    switch (test.priorityWords) {
      case 3:
        test.priorityWords = translate('b2b_High');
        break;
      case 4:
        test.priorityWords = translate('b2b_Normal');
        break;
      case 5:
        test.priorityWords = translate('b2b_Low');
        break;
    }

    // * checking if a thread exists and if is true i am formating the date
    if (test.thread) {
      test.thread.map(thread => {
        // thread.c_stamp = moment.utc(thread.c_stamp).local().format('DD-MM-YYYY HH:mm:ss')
        // thread.m_stamp = moment.utc(thread.m_stamp).local().format('DD-MM-YYYY HH:mm:ss')
        // * if from_contact_name is  not empty then we show as name the from_contact_name
        if (thread.from_contact_name != null) {
          thread.name = thread.from_contact_name;
        }
      });
      // console.log(test.thread)
    }
  });
  let z = x[0];
  return z;
}
/**
 * * fetching ticket types ,that are used in new ticket modal, to post a new ticket
 */
export function getTicketTypes () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.TicketTypeApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response.data)
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' + store.state.data.hostname + echoApi.TicketTypeApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response.data)
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}
// GET COMM LOG DATA
export function getCommLogData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.CommApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response.data)
        response.data.map(comm => {
          comm.date = setDateFormatFromUtc(comm.c_stamp);
          comm.time = setTimeFormatFromUtc(comm.c_stamp);
          comm.c_stamp = setDateTimeFormatFromUtc(comm.c_stamp);
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.CommApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                response.data.map(comm => {
                  comm.date = setDateFormatFromUtc(comm.c_stamp);
                  comm.date = setTimeFormatFromUtc(comm.c_stamp);
                  comm.c_stamp = setDateTimeFormatFromUtc(comm.c_stamp);
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function getFilteredCommLogData (commData) {
  // console.log(commData)
  var Avatar = translate('Avatar');
  var FullName = translate('Full_Name');
  var Channel = translate('Channel');
  var Description = translate('Description');
  var Date = translate('Date');
  var Time = translate('Time');
  let tableData = commData.map(comm => {
    let obj = {};
    // let UnixDate = commData.c_stamp
    // var zone = (moment.tz.guess())
    // alert(moment(commData.c_stamp).tz(zone).format('HH:mm'))
    // alert(moment(comm.c_stamp).tz('Europe/Athens').format())
    obj[Avatar] =
      'https://' + store.state.data.hostname + echoApi.AvatarApi + comm.to_id;
    obj[FullName] = comm.to_name;
    obj[Channel] = comm.channel_type;
    obj[Description] = comm.content;
    obj[Date] = moment
      .utc(comm.c_stamp)
      .local()
      .format('DD MMM YYYY');
    obj[Time] = moment
      .utc(comm.c_stamp)
      .local()
      .format('HH:mm');
    obj.id = comm.id;
    return obj;
  });
  tableData['columns'] = [
    { label: Avatar },
    { label: FullName },
    { label: Channel },
    { label: Description },
    { label: Date },
    { label: Time }
  ];
  // console.log(tableData)
  return tableData;
}
// GET LOG DATA & FORMAT
export function getLogData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.LogsApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        response.data.map(log => {
          log.date = setDateFormatFromUtc(log.m_stamp);
          log.time = setTimeFormatFromUtc(log.m_stamp);
          log.m_stamp = setDateTimeFormatFromUtc(log.m_stamp);
        });
        resolve(response.data.reverse());
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.LogsApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                response.data.map(log => {
                  log.date = setDateFormatFromUtc(log.m_stamp);
                  log.time = setTimeFormatFromUtc(log.m_stamp);
                  log.m_stamp = setDateTimeFormatFromUtc(log.m_stamp);
                });
                resolve(response.data.reverse());
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

/**
 *
 * * @param {*} data
 * * i am formatting the LogData creating an object that also includes the headings of table's collumns. The generic table component needs the headings to create
 * * the collumns that are needed to display the data
 */
export function formatLogData (data) {
  // var cDate = moment()
  var Avatar = '';
  var Fullname = translate('Full_name');
  var Actions = translate('Actions');
  var Location = translate('Location_ip');
  var Date = translate('Date');
  var Time = translate('Time');
  let tableData = data.map(log => {
    // let UnixDate = commData.c_stamp
    // var zone = (moment.tz.guess())
    // alert(moment(commData.c_stamp).tz(zone).format('HH:mm'))
    // alert(moment(comm.c_stamp).tz('Europe/Athens').format())
    // var b = log.m_stamp
    // cDate.diff(b, 'days')
    let obj = {};
    let avat;
    if (log.avatar) {
      avat = log.contact_id + '.' + log.avatar;
    } else {
      avat =
        'https://' +
        store.state.data.hostname +
        '/echo/files/avatars/' +
        log.contact_id +
        '.' +
        log.avatar;
    }
    obj[Avatar] = avat;
    obj[Fullname] = log.fullname;
    obj[Actions] = log.status;
    obj[Location] = log.ip;
    // obj[Date] = cDate.diff(b, 'days') + ' ' + i18n.t('tables.DaysAgo')
    obj[Date] = log.date;
    obj[Time] = log.time;
    obj.id = log.id;
    return obj;
  });
  tableData['columns'] = [
    { label: Avatar },
    { label: Fullname },
    { label: Actions },
    { label: Location },
    { label: Date },
    { label: Time }
  ];
  // console.log(tableData)
  return tableData.reverse();
}
// GET ALL ACTIVITY
export function getActivityData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.ActivitiesApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        response.data.logs.map(log => {
          log.date = setDateFormatFromUtc(log.m_stamp);
          log.time = setTimeFormatFromUtc(log.m_stamp);
          log.m_stamp = setDateTimeFormatFromUtc(log.m_stamp);
        });
        response.data.comms.map(comm => {
          comm.date = setDateFormatFromUtc(comm.c_stamp);
          comm.time = setTimeFormatFromUtc(comm.c_stamp);
          comm.c_stamp = setDateTimeFormatFromUtc(comm.c_stamp);
        });
        response.data.transactions.map(transaction => {
          transaction.date = setDateFormatFromUtc(transaction.c_stamp);
          transaction.time = setTimeFormatFromUtc(transaction.c_stamp);
          transaction.c_date = setDateFormatFromUtc(transaction.c_date);
          transaction.c_stamp = setDateTimeFormatFromUtc(transaction.c_stamp);
          transaction.m_stamp = setDateTimeFormatFromUtc(transaction.m_stamp);
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' + store.state.data.hostname + echoApi.ActivitiesApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response.data)
                response.data.logs.map(log => {
                  log.date = setDateFormatFromUtc(log.m_stamp);
                  log.time = setTimeFormatFromUtc(log.m_stamp);
                  log.m_stamp = setDateTimeFormatFromUtc(log.m_stamp);
                });
                response.data.comms.map(comm => {
                  comm.date = setDateFormatFromUtc(comm.c_stamp);
                  comm.time = setTimeFormatFromUtc(comm.c_stamp);
                  comm.c_stamp = setDateTimeFormatFromUtc(comm.c_stamp);
                });
                response.data.transactions.map(transaction => {
                  transaction.date = setDateFormatFromUtc(transaction.c_stamp);
                  transaction.time = setTimeFormatFromUtc(transaction.c_stamp);
                  transaction.c_date = setDateFormatFromUtc(transaction.c_date);
                  transaction.c_stamp = setDateTimeFormatFromUtc(
                    transaction.c_stamp
                  );
                  transaction.m_stamp = setDateTimeFormatFromUtc(
                    transaction.m_stamp
                  );
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function formatActivities (data) {
  let tableData = [];
  data.comms.map(com => {
    let obj = {};
    obj['fullname'] = com.to_name;
    obj['desc'] = com.content;
    obj['avatar'] = com.avatar;
    obj['to_id'] = com.to_id;
    obj['date'] = com.date;
    obj['time'] = com.time;
    tableData.push(obj);
  });
  data.logs.map(log => {
    let obj = {};
    obj['fullname'] = log.contact_name;
    obj['avatar'] = null;
    obj['desc'] = log.status;
    obj['to_id'] = null;
    obj['date'] = log.date;
    obj['time'] = log.time;
    tableData.push(obj);
  });
  data.transactions.map(transaction => {
    let obj = {};
    obj['fullname'] = transaction.contact_name;
    obj['avatar'] = null;
    obj['desc'] = transaction.etiology;
    obj['to_id'] = null;
    obj['date'] = transaction.date;
    obj['time'] = transaction.time;
    tableData.push(obj);
  });
  return tableData.reverse();
}

// GET ALL TRANSACTIONS
export function getAllTransactionsData () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.TransactionsApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        response.data.map(transaction => {
          transaction.date = setDateFormatFromUtc(transaction.c_stamp);
          transaction.time = setTimeFormatFromUtc(transaction.c_stamp);
          transaction.c_stamp = setDateTimeFormatFromUtc(transaction.c_stamp);
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' +
                  store.state.data.hostname +
                  echoApi.TransactionsApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response.data)
                response.data.map(transaction => {
                  transaction.date = setDateFormatFromUtc(transaction.c_stamp);
                  transaction.time = setTimeFormatFromUtc(transaction.c_stamp);
                  transaction.c_stamp = setDateTimeFormatFromUtc(
                    transaction.c_stamp
                  );
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function formatAllTransactionsData (data) {
  // console.log(commData)
  var Transactiontype = translate('Transaction_type');
  var TotalAmount = translate('Total_amount');
  var Description = translate('Description');
  var Date = translate('Date');
  var Time = translate('Time');
  let tableData = data.map(transaction => {
    // let UnixDate = commData.c_stamp
    // var zone = (moment.tz.guess())
    // alert(moment(commData.c_stamp).tz(zone).format('HH:mm'))
    // alert(moment(comm.c_stamp).tz('Europe/Athens').format())
    switch (transaction.circuit_code) {
      case 1:
        transaction.circuit_code = translate('Purchases');
        break;
      case 5:
        transaction.circuit_codepe = translate('Sales');
        break;
      case 7:
        transaction.circuit_code = translate('Collections_payments');
        break;
      case 10:
        transaction.circuit_code = translate('Expenses');
        break;
      case 15:
        transaction.circuit_code = translate('Services');
        break;
      case 20:
        transaction.circuit_code = translate('Inventory');
        break;
      case 25:
        transaction.circuit_code = translate('Purchases_orders');
        break;
      case 26:
        transaction.circuit_code = translate('Expenses_orders');
        break;
      case 30:
        transaction.circuit_code = translate('Sales_offers');
        break;
      case 35:
        transaction.circuit_code = translate('Sales_order');
        break;
      case 36:
        transaction.circuit_code = translate('Services_offers ');
        break;
      case 39:
        transaction.circuit_code = translate('Services_orders');
        break;
      case 40:
        transaction.circuit_code = translate('Third_party_items');
        break;
      case 45:
        transaction.circuit_code = translate('Items_to_others');
        break;
      case 60:
        transaction.circuit_code = translate('Bulk_movements_of_securities');
        break;
    }
    let obj = {};
    obj[Transactiontype] = transaction.circuit_code;
    obj[Description] = transaction.etiology;
    obj[TotalAmount] = transaction.total_value_final.toFixed(2);
    obj[Date] = transaction.date;
    obj[Time] = transaction.time;
    obj.id = transaction.id;
    return obj;
  });
  tableData['columns'] = [
    { label: Transactiontype },
    { label: TotalAmount },
    { label: Description },
    { label: Date },
    { label: Time }
  ];
  // console.log(tableData)
  return tableData;
}

// GET SUBSCRIPTIONS
export function getSubscriptions () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.SubsApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        console.log(response.data);
        response.data.map(subscription => {
          subscription.end_date = setDateFormatFromUtc(
            subscription.renewal.end_date
          );
          subscription.start_date = setDateFormatFromUtc(
            subscription.renewal.start_date
          );
          if (subscription.renewal) {
            subscription.renewal.renewal_start_date = setDateFormatFromUtc(
              subscription.renewal.renewal_start_date
            );
            subscription.renewal.renewal_end_date = setDateFormatFromUtc(
              subscription.renewal.renewal_end_date
            );
          }
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.SubsApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                response.data.map(subscription => {
                  subscription.end_date = setDateFormatFromUtc(
                    subscription.renewal.end_date
                  );
                  subscription.start_date = setDateFormatFromUtc(
                    subscription.renewal.start_date
                  );
                  if (subscription.renewal) {
                    subscription.renewal.renewal_start_date = setDateFormatFromUtc(
                      subscription.renewal.renewal_start_date
                    );
                    subscription.renewal.renewal_end_date = setDateFormatFromUtc(
                      subscription.renewal.renewal_end_date
                    );
                  }
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

// GET ORDERS DATA & FORMAT
export function getOrders () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.OrdersApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        response.data.map(order => {
          // order.formatedDate = setStampFormatFromUnix(order.date)
          order.FormatedDate = setDateTimeFormatFromUnix(order.date);
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.OrdersApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                response.data.map(order => {
                  order.FormatedDate = setDateTimeFormatFromUnix(order.date);
                });
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function getLatestOrders (orders) {
  // let curDate = moment().unix()
  let PastDate = moment().subtract(30, 'days');
  var old = [];
  PastDate = moment(PastDate).unix();
  // alert(PastDate)
  // let orderDate
  // let dayDiff
  orders.map(order => {
    // if (order.date > PastDate) {
    //   alert('megaliteri' + order.date + ',' + PastDate)
    // }
    if (order.date > PastDate) {
      old.push(order);
    }
  });
  return old.reverse();
}
export function getArchivedOrders (orders) {
  // let curDate = moment().unix()
  let PastDate = moment().subtract(30, 'days');
  var old = [];
  PastDate = moment(PastDate).unix();
  // alert(PastDate)
  // let orderDate
  // let dayDiff
  orders.map(order => {
    // if (order.date > PastDate) {
    //   alert('megaliteri' + order.date + ',' + PastDate)
    // }
    if (order.date < PastDate) {
      old.push(order);
    }
  });
  return old.reverse();
}
export function getOrderDetails (id, orders) {
  let x = orders.filter(details => details.id === id);
  let z = x[0];
  return z;
}

// GET Announcments
export function getAnnouncments () {
  let accountId = store.state.data.UserData.account_id;
  return new Promise((resolve, reject) => {
    axios
      .get(
        'https://' +
          store.state.data.hostname +
          echoApi.AnnouncmentsApi +
          accountId,
        { headers: echoApi.getHeader() }
      )
      .then(function (response) {
        // handle success
        // console.log(response.data)
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(response => {
            axios
              .get(
                'https://' +
                  store.state.data.hostname +
                  echoApi.AnnouncmentsApi +
                  accountId,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response.data)
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function formatAnnouncments (Announcments) {
  return Announcments.filter(
    notification =>
      parseInt(notification.type) === 6 &&
      parseInt(notification.alert_type) === 2
  );
}

// GET TRANSLATIONS
export function getTranslations () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.TranslationsApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response.data)
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' +
                  store.state.data.hostname +
                  echoApi.TranslationsApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response.data)
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

// GET PAGES
export function getPages () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.PagesApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response.data)
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.PagesApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}
/**
 * * employes in about us page
 */
// GET EMPLOYEES
export function getEmployees () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.EmployeesApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        var sort = _.orderBy(response.data, 'f_name', 'asc');
        for (let index in sort) {
          if (sort[index].hasOwnProperty('phone')) {
            sort[index].phone = sort[index].phone.replace(/"/g, '');
          }
          if (sort[index].hasOwnProperty('mobile')) {
            sort[index].mobile = sort[index].mobile.replace(/"/g, '');
          }
        }
        resolve(sort);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' + store.state.data.hostname + echoApi.EmployeesApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                var sort = _.orderBy(response.data, 'f_name', 'asc');
                for (let index in sort) {
                  if (sort[index].hasOwnProperty('phone')) {
                    sort[index].phone = sort[index].phone.replace(/"/g, '');
                  }
                  if (sort[index].hasOwnProperty('mobile')) {
                    sort[index].mobile = sort[index].mobile.replace(/"/g, '');
                  }
                }
                resolve(sort);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}

// GET Company Details
export function getCompanyDetails () {
  let accountId = store.state.data.UserData.account_id;
  return new Promise((resolve, reject) => {
    axios
      .get(
        'https://' +
          store.state.data.hostname +
          echoApi.CompanyDetailsApi +
          accountId,
        { headers: echoApi.getHeader() }
      )
      .then(function (response) {
        // handle success
        if (response.data.url && !response.data.url.startsWith('http')) {
          response.data.fullurl = 'https://' + response.data.url;
        }
        if (response.data.twitter && !response.data.url.startsWith('http')) {
          response.data.fulltwitter =
            'https://www.twitter.com/' + response.data.twitter;
        }
        if (response.data.facebook && !response.data.url.startsWith('http')) {
          response.data.fullfacebook =
            'https://www.facebook.com/' + response.data.facebook;
        }
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' +
                  store.state.data.hostname +
                  echoApi.CompanyDetailsApi +
                  accountId,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                // handle success
                // console.log(response.data)
                if (
                  response.data.url &&
                  !response.data.url.startsWith('http')
                ) {
                  response.data.fullurl = 'https://' + response.data.url;
                }
                if (
                  response.data.twitter &&
                  !response.data.url.startsWith('http')
                ) {
                  response.data.fulltwitter =
                    'https://www.twitter.com/' + response.data.twitter;
                }
                if (
                  response.data.facebook &&
                  !response.data.url.startsWith('http')
                ) {
                  response.data.fullfacebook =
                    'https://www.facebook.com/' + response.data.facebook;
                }
                resolve(response.data);
              });
          });
        } else {
          reject(error);
        }
      });
  });
}
// GET B2B USERS
export function getUsers () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.UsersApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        // handle success
        // console.log(response.data)
        // localStorage.setItem('authUser2', btoa(JSON.stringify(response.data)))
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.UsersApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                // handle success
                // console.log(response.data)
                resolve(response.data);
              });
          });
        }
        reject(error);
      });
  });
}

// GET FILES
export function getFiles () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.FilesApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        response.data.map(file => {
          if (file.c_stamp) {
            file.c_date = setDateFormatFromUtc(file.c_stamp);
            file.c_stamp = setDateTimeFormatFromUtc(file.c_stamp);
          }
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.FilesApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                response.data.map(file => {
                  file.c_date = setDateFormatFromUtc(file.c_stamp);
                  file.c_stamp = setDateTimeFormatFromUtc(file.c_stamp);
                });
                resolve(response.data);
              });
          });
        }
        reject(error);
      });
  });
}

export function getTicketFiles () {
  return new Promise((resolve, reject) => {
    axios
      .get(
        'https://' +
          store.state.data.hostname +
          echoApi.FilesApi +
          '/' +
          store.state.data.TicketDetailsId,
        { headers: echoApi.getHeader() }
      )
      .then(function (response) {
        response.data.map(file => {
          if (file.c_stamp) {
            file.c_date = setDateFormatFromUtc(file.c_stamp);
            file.c_stamp = setDateTimeFormatFromUtc(file.c_stamp);
          }
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get('https://' + store.state.data.hostname + echoApi.FilesApi, {
                headers: echoApi.getHeader()
              })
              .then(function (response) {
                response.data.map(file => {
                  file.c_date = setDateFormatFromUtc(file.c_stamp);
                  file.c_stamp = setDateTimeFormatFromUtc(file.c_stamp);
                });
                resolve(response.data);
              });
          });
        }
        reject(error);
      });
  });
}

export function formatFiles (data) {
  // console.log(data)
  return data.reverse();
}

export function formatUsersData (data) {
  // var cDate = moment()
  var Name = translate('Full_name');
  var Type = translate('User_type');
  let tableData = data.map(log => {
    // let UnixDate = commData.c_stamp
    // var zone = (moment.tz.guess())
    // alert(moment(commData.c_stamp).tz(zone).format('HH:mm'))
    // alert(moment(comm.c_stamp).tz('Europe/Athens').format())
    // var b = log.m_stamp
    // cDate.diff(b, 'days')
    let obj = {};
    obj[Name] = log.name;
    obj[Type] = log.type;
    // obj[Date] = cDate.diff(b, 'days') + ' ' + i18n.t('tables.DaysAgo')
    return obj;
  });
  tableData['columns'] = [{ label: Name }, { label: Type }];
  // console.log(tableData)
  return tableData;
}

/**
 *
 * * @param {*} data
 * * returns the length of data given
 */
export function getDataLength (data) {
  return data.length;
}

// GET INVOICES
export function getInvoices () {
  return new Promise((resolve, reject) => {
    axios
      .get('https://' + store.state.data.hostname + echoApi.InvoicesApi, {
        headers: echoApi.getHeader()
      })
      .then(function (response) {
        response.data.invoices_details.map(invoice => {
          invoice.c_stamp = setDateTimeFormatFromUtc(invoice.c_stamp);
          invoice.m_stamp = setDateTimeFormatFromUtc(invoice.m_stamp);
          invoice.invoice_date = setDateFormatFromUtc(invoice.invoice_date);
        });
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        if (error.response.status === 401) {
          echoApi.refreshToken().then(resposne => {
            axios
              .get(
                'https://' + store.state.data.hostname + echoApi.InvoicesApi,
                { headers: echoApi.getHeader() }
              )
              .then(function (response) {
                response.data.invoices_details.map(invoice => {
                  invoice.c_stamp = setDateTimeFormatFromUtc(invoice.c_stamp);
                  invoice.m_stamp = setDateTimeFormatFromUtc(invoice.m_stamp);
                  invoice.invoice_date = setDateFormatFromUtc(
                    invoice.invoice_date
                  );
                });
                resolve(response.data);
              });
          });
        }
        reject(error);
      });
  });
}

export function filterInvoices (data, status) {
  var paid;
  if (status === 'paid') {
    paid = data.invoices_details.filter(invoice => {
      return invoice.transaction_type !== 2;
    });
  } else if (status === 'unpaid') {
    paid = data.invoices_details.filter(invoice => {
      return invoice.transaction_type === 2;
    });
  }
  return paid;
}

/**
 * * sidebar menu
 */
export function getMenu () {
  var menus;
  if (store.state.data.ApiPage) {
    menus = [
      {
        // translate('Dashboard')
        title: 'Dashboard',
        linkName: 'dashboard',
        icon: 'dashboard'
      },
      {
        title: 'Schedule',
        linkName: 'schedule',
        icon: 'tickets'
      },
      {
        title: 'Requests',
        linkName: 'requests',
        icon: 'account'
      },
      {
        // translate('b2b_orders')
        title: 'checklists',
        linkName: 'checklists',
        icon: 'orders'
      },
      {
        title: 'directory',
        linkName: 'directory',
        icon: 'subscriptions'
      },
      // {
      //   title: translate('b2b_account'),
      //   linkName: 'account',
      //   icon: 'account',
      //   submenus: [
      //     {
      //       title: translate('b2b_activity'),
      //       linkName: 'activity',
      //       icon: 'activity'
      //     },
      //     { title: translate('b2b_files'), linkName: 'files', icon: 'files' }
      //     // {title: translate('b2b_users'), linkName: 'users', icon: 'users'}
      //   ]
      // },
      {
        title: translate('b2b_about_us'),
        linkName: 'about',
        icon: 'aboutus'
      }
      // {title: 'custom page', linkName: 'custom page', icon: 'custompage'}
    ];
  } else {
    menus = [
      {
        // translate('Dashboard')
        title: 'Dashboard',
        linkName: 'dashboard',
        icon: 'dashboard'
      },
      {
        title: 'Schedule',
        linkName: 'schedule',
        icon: 'tickets'
      },
      {
        // translate('b2b_orders')
        title: 'checklists',
        linkName: 'checklists',
        icon: 'orders'
      },
      {
        title: 'directory',
        linkName: 'directory',
        icon: 'subscriptions'
      },
      {
        title: 'About Us',
        linkName: 'about',
        icon: 'aboutus'
      }
      // {title: 'custom page', linkName: 'custom page', icon: 'custompage'}
    ];
  }
  return menus;
}

function setDateTimeFormatFromUnix (data) {
  var stamp = store.state.data.UserData.stamp_format[0];
  stamp.date = stamp.date.toUpperCase();
  var stampFormat = moment.unix(data).format(stamp.date + ' ' + stamp.time);
  return stampFormat;
}

function setDateFormatFromUnix (data) {
  var stamp = store.state.data.UserData.stamp_format[0];
  stamp.date = stamp.date.toUpperCase();
  var stampFormat = moment.unix(data).format(stamp.date);
  return stampFormat;
}

function setTimeFormatFromUnix (data) {
  var stamp = store.state.data.UserData.stamp_format[0];
  stamp.date = stamp.date.toUpperCase();
  var stampFormat = moment.unix(data).format(stamp.time);
  return stampFormat;
}

function setDateTimeFormatFromUtc (data) {
  var stamp = store.state.data.UserData.stamp_format[0];
  stamp.date = stamp.date.toUpperCase();
  var stampFormat = moment
    .utc(data)
    .local()
    .format(stamp.date + ' ' + stamp.time);
  return stampFormat;
}

function setDateFormatFromUtc (data) {
  var stamp = store.state.data.UserData.stamp_format[0];
  stamp.date = stamp.date.toUpperCase();
  var stampFormat = moment
    .utc(data)
    .local()
    .format(stamp.date);
  return stampFormat;
}

function setTimeFormatFromUtc (data) {
  var stamp = store.state.data.UserData.stamp_format[0];
  stamp.date = stamp.date.toUpperCase();
  var stampFormat = moment
    .utc(data)
    .local()
    .format(stamp.time);
  return stampFormat;
}



// WEBPACK FOOTER //
// ./src/utils/ApiFunctionCalls.js